module.exports = __webpack_public_path__ + "static/img/push-todo-icon.b6456774.svg";